import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Row, Col, Button, Panel, Modal, ButtonToolbar } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import reasonCodes from 'config/reason-codes';
import DropdownButton from 'components/ui/tailwind/DropdownButton';
import { isDrayageShipment } from 'helpers/shipment-types';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
const DATE_FORMAT = 'L LT';
class ShipmentWindowChange extends Component {
    constructor(props) {
        super(props);
        this.onStopWindowOpenChange = (timeStamp) => {
            this.setState({ window_start: timeStamp });
        };
        this.onStopWindowCloseChange = (timeStamp) => {
            this.setState({ window_end: timeStamp });
        };
        this.onToggleAppointmentConfirmed = (e) => {
            const { target: { checked }, } = e;
            this.setState({
                appointment_unconfirmed: !checked,
            });
        };
        const { stop: { window_start, window_end, appointment_unconfirmed }, } = props;
        this.state = {
            window_start,
            window_end,
            appointment_unconfirmed,
            name: '',
        };
    }
    UNSAFE_componentWillReceiveProps(props) {
        if (!this.props.show && props.show) {
            const { stop: { window_start, window_end, appointment_unconfirmed }, } = props;
            this.setState({
                window_start,
                window_end,
                appointment_unconfirmed,
            });
        }
    }
    onReasonSelect(reason) {
        this.setState({ value: reason.value, name: reason.name });
    }
    closeModal() {
        this.setState({
            value: '',
            name: '',
            window_start: null,
            window_end: null,
            appointment_unconfirmed: false,
        }, this.props.onHideModal());
    }
    renderBody() {
        const { window_start, window_end } = this.state;
        const { shipment, stop, t } = this.props;
        const showConfirmCheckbox = isDrayageShipment(shipment) && !stop.empty;
        return (React.createElement("div", null,
            React.createElement(Panel, null,
                React.createElement("div", { className: "flex flex-wrap -mx-4" },
                    React.createElement("div", { className: "px-4" },
                        React.createElement("strong", null, t('PICK_UP'))),
                    React.createElement("div", { className: "px-4 md:w-1/3" },
                        React.createElement("label", { className: "w-full form-label mb-2" }, t('START')),
                        React.createElement(DatePicker, { className: "w-full form-field mb-4", dateFormat: DATE_FORMAT, isClearable: true, placeholderText: t('WINDOW_START'), onChange: this.onStopWindowOpenChange, selected: getMomentDate(window_start), timeIntervals: 15, showTimeSelect: true })),
                    React.createElement("div", { className: "px-4 md:w-1/3" },
                        React.createElement("label", { className: "w-full form-label mb-2" }, t('END')),
                        React.createElement(DatePicker, { className: "w-full form-field mb-4", timeIntervals: 15, dateFormat: DATE_FORMAT, isClearable: true, onChange: this.onStopWindowCloseChange, placeholderText: t('WINDOW_END'), selected: getMomentDate(window_end), showTimeSelect: true })),
                    showConfirmCheckbox && (React.createElement("div", null,
                        React.createElement("label", { className: "w-full form-label mb-2 block" }, t('CONFIRMED')),
                        React.createElement("input", { type: "checkbox", checked: !this.state.appointment_unconfirmed, onChange: this.onToggleAppointmentConfirmed }))))),
            React.createElement(Row, { style: { marginTop: 10 } },
                React.createElement(Col, { xs: 5 },
                    React.createElement("p", null, t('SELECT_REASON_FOR_WINDOW_CHANGE'))),
                React.createElement(Col, { xs: 7 },
                    React.createElement("div", { className: "z-100" },
                        React.createElement(DropdownButton, { onSelect: (reason) => this.onReasonSelect(reason), items: reasonCodes, title: this.state.name || t('SELECT_REASON') }))))));
    }
    render() {
        if (!this.props.stop)
            return null;
        const { t } = this.props;
        const stop = this.props.stop;
        const body = this.props.show ? this.renderBody() : null;
        return (React.createElement(Modal, { show: this.props.show, onHide: () => this.props.onHideModal(), enforceFocus: false },
            React.createElement(Modal.Header, { closeButton: true },
                React.createElement(Modal.Title, null, t('STOP_WINDOW_CHANGE_SEQUENCE', { sequence: stop.sequence }))),
            React.createElement(Modal.Body, null, body),
            React.createElement(Modal.Footer, null,
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(ButtonToolbar, { style: { float: 'right' } },
                            React.createElement(Button, { onClick: () => this.closeModal() }, t('CANCEL')),
                            React.createElement(Button, { bsStyle: "primary", onClick: () => {
                                    this.props.onSave(this.state);
                                    this.props.onHideModal();
                                }, disabled: this.state.reason === '' && this.state.description === '' }, t('UPDATE_JOB'))))))));
    }
}
ShipmentWindowChange.propTypes = {
    stop: PropTypes.object,
    shipment: PropTypes.object,
    show: PropTypes.bool.isRequired,
};
ShipmentWindowChange.propTypes = {
    onHideModal: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    stop: PropTypes.shape({
        window_start: PropTypes.string,
        window_end: PropTypes.string,
    }).isRequired,
};
function getMomentDate(dateStr) {
    if (!dateStr) {
        return null;
    }
    return moment(dateStr);
}
export default withTranslation()(ShipmentWindowChange);
